import { render, staticRenderFns } from "./TableGallery.vue?vue&type=template&id=fce371aa"
import script from "./TableGallery.vue?vue&type=script&lang=js"
export * from "./TableGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports